var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-md-8 col-8 left-side" }, [
            _vm.$router.currentRoute.name == "globalAlert"
              ? _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "header-filter-btns",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("createNewAlert")
                          }
                        }
                      },
                      [
                        _vm._v("\n            Add Alert\n            "),
                        _c("i", {
                          staticClass: "fas text-primary fa-plus fa-fw"
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$router.currentRoute.name != "permissionManager" &&
            _vm.$router.currentRoute.name != "globalAlert" &&
            _vm.$router.currentRoute.name != "userGlobalAlert"
              ? _c(
                  "div",
                  {
                    class:
                      "form-inline " +
                      (_vm.$router.currentRoute.name == "dashboard" ||
                      _vm.$router.currentRoute.name == "myWeek"
                        ? "deliverable-filter-form"
                        : "")
                  },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.setQuery,
                            expression: "setQuery",
                            arg: "500ms"
                          }
                        ],
                        ref: "searchQuery",
                        staticClass: "form-control",
                        class:
                          _vm.$router.currentRoute.name == "globalSearch"
                            ? ""
                            : "media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder: _vm.querySearchPlaceHolder,
                          id: "search-query"
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          click: function($event) {
                            return _vm.$refs.searchQuery.select()
                          },
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.triggerSearch.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.triggerSearch }
                        },
                        [_vm._m(0)]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch"
                      ? _c(
                          "b-button",
                          {
                            ref: "filterBoxBtn",
                            staticClass: "ml-2 mr-2 header-filter-btns",
                            attrs: {
                              id: "popover-button-event",
                              variant: "theme",
                              tabindex: "0",
                              href: "#"
                            },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.$refs.popover.$emit("close")
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "wider-filter-only":
                                    _vm.$router.currentRoute.name ==
                                      "dashboard" ||
                                    _vm.$router.currentRoute.name == "myWeek"
                                }
                              },
                              [_vm._v("Filter")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/filter.svg")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          triggers: "click blur",
                          boundary: "window",
                          placement: "bottom",
                          target: "popover-button-event",
                          "custom-class": "deliverable-filter"
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item item__status" },
                            [
                              _c("label", [_vm._v("Post Status")]),
                              _vm._v(" "),
                              !_vm.isMobile()
                                ? _c(
                                    "div",
                                    { staticClass: "status-wrap" },
                                    _vm._l(_vm.publishStatuses, function(
                                      s,
                                      index
                                    ) {
                                      return _c(
                                        "a",
                                        {
                                          key: index,
                                          staticClass: "badge mr-2",
                                          style: {
                                            color: "#fff",
                                            backgroundColor: s.color
                                          },
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.setPublishStatusFilter(
                                                s
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-field status-field" },
                                [
                                  _vm.isMobile()
                                    ? _c("multiselect", {
                                        attrs: {
                                          searchable: true,
                                          label: "name",
                                          options: _vm.publishStatuses,
                                          placeholder: "Select post status",
                                          "show-labels": false,
                                          multiple: true,
                                          "hide-selected": true
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        height: "40px",
                                                        lineHeight: "40px",
                                                        textAlign: "center"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "tag",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        padding: "5px 10px",
                                                        marginRight: "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3982085681
                                        ),
                                        model: {
                                          value: _vm.filterQuery.publishStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "publishStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.publishStatus"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__coordinator" },
                              [
                                _c("label", [_vm._v("Assigned To")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "coordinator-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "coordinatorFilter",
                                      attrs: {
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "name",
                                        "track-by": "id",
                                        hideSelected: false,
                                        "hide-selected": false,
                                        "close-on-select": false,
                                        "clear-on-select": false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        249740006
                                      ),
                                      model: {
                                        value: _vm.filterQuery.coordinator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterQuery,
                                            "coordinator",
                                            $$v
                                          )
                                        },
                                        expression: "filterQuery.coordinator"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-item item__social_network"
                                  },
                                  [
                                    _c("label", [_vm._v("Social Network")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "social-network-wrap" },
                                      [
                                        _c("multiselect", {
                                          ref: "socialNetworkFilter",
                                          attrs: {
                                            options:
                                              _vm.systemSettings
                                                .social_networks || [],
                                            "show-labels": false,
                                            multiple: true,
                                            "open-direction": "bottom",
                                            label: "network_name",
                                            "track-by": "id",
                                            hideSelected: false,
                                            "hide-selected": false,
                                            "close-on-select": false,
                                            "clear-on-select": false,
                                            "preserve-search": true,
                                            loading: !_vm.systemSettings
                                              .social_networks
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "option",
                                                fn: function(props) {
                                                  return [
                                                    _c("div", [
                                                      _c("i", {
                                                        class:
                                                          "fab fa-" +
                                                          props.option.api_type
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.option
                                                              .network_name
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                }
                                              },
                                              {
                                                key: "selection",
                                                fn: function(ref) {
                                                  var values = ref.values
                                                  var search = ref.search
                                                  var isOpen = ref.isOpen
                                                  return [
                                                    values.length && !isOpen
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "multiselect__single"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                values.length
                                                              ) +
                                                                " options selected"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3509753195
                                          ),
                                          model: {
                                            value:
                                              _vm.filterQuery.socialNetwork,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "socialNetwork",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filterQuery.socialNetwork"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__tag" },
                                  [
                                    _c("label", [_vm._v("Tag")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tag-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "tagFilter",
                                            attrs: {
                                              options: _vm.tags,
                                              "show-labels": false,
                                              multiple: true,
                                              "open-direction": "bottom",
                                              label: "name",
                                              "track-by": "id",
                                              hideSelected: false,
                                              "hide-selected": false,
                                              "close-on-select": false,
                                              "clear-on-select": false,
                                              loading: _vm.isTagsLoading,
                                              "preserve-search": true
                                            },
                                            on: {
                                              "search-change": _vm.onTagSearch
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              249740006
                                            ),
                                            model: {
                                              value: _vm.filterQuery.tag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "tag",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.tag"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find tags."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item item__department" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [_vm._v("Department")]),
                                    _vm._v(" "),
                                    _vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "float-right csm-checkbox",
                                            attrs: {
                                              id: "no-department",
                                              name: "no-department",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noDepartment ==
                                                "accepted"
                                                  ? (_vm.filterQuery.department = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.noDepartment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noDepartment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.noDepartment"
                                            }
                                          },
                                          [_vm._v("No Department")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "departmentFilter",
                                        attrs: {
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          options: _vm.allActiveDepartments,
                                          hideSelected: false,
                                          "hide-selected": false,
                                          "show-labels": false,
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false
                                        },
                                        on: {
                                          select: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          249740006
                                        ),
                                        model: {
                                          value: _vm.filterQuery.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.department"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v(
                                            "Start typing to find departments."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.filterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noDepartment"
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filter-item item__date",
                              class: {
                                "filter-item-no-border":
                                  _vm.$router.currentRoute.name == "calendar"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "due__created__dates" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-2" }, [
                                        _vm._v("Created")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerDateCreated",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customCreatedDateRanges
                                        },
                                        on: { update: _vm.onUpdateDateCreated },
                                        model: {
                                          value:
                                            _vm.filterQuery.dateCreatedRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateCreatedRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.dateCreatedRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.checkCalendarMode([
                                    "deliverables",
                                    "tasks"
                                  ])
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "mt-lg-2" },
                                            [_vm._v("Post Date")]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("date-range-picker", {
                                            ref: "pickerPublishDate",
                                            attrs: {
                                              autoApply: true,
                                              ranges:
                                                _vm.customPublishDateRanges
                                            },
                                            on: {
                                              update: _vm.onUpdatePublishDate
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery
                                                  .datePublishRange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "datePublishRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.datePublishRange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "item__reset" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "theme",
                                      title: "Reset All Filter",
                                      size: "sm"
                                    },
                                    on: { click: _vm.resetFilter }
                                  },
                                  [_c("i", { staticClass: "fas fa-undo" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "d-block d-lg-none",
                                    attrs: {
                                      variant: "theme",
                                      title: "Close Filter Popup",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.popover.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isFilterActive()
                          ? _c(
                              "div",
                              { staticClass: "d-none d-md-block mt-3" },
                              [
                                _c("label", [
                                  _vm._v("Click to remove filters :")
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.query = null
                                        _vm.searchQuery = ""
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.filterQuery.query))]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.publishStatus, function(
                                  publishStatus
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass: "badge mr-2 mb-2",
                                      style: {
                                        cursor: "pointer",
                                        color: "#fff",
                                        backgroundColor: publishStatus.color
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(publishStatus)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(publishStatus.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.socialNetwork, function(
                                  socialNetwork
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge mr-2 mb-2 bg-primary cursor-pointer",
                                      staticStyle: { color: "#fff" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(socialNetwork)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          "fab fa-" + socialNetwork.api_type
                                      }),
                                      _vm._v(
                                        " " + _vm._s(socialNetwork.network_name)
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.coordinator, function(
                                  coordinator
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(coordinator)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(coordinator.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.filterQuery.filterByDateCreated
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByDateCreated"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Created: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateCreatedRange
                                                  .startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.dateCreatedRange
                                                  .endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filterQuery.filterByPublishDate
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByPublishDate"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Date to Post: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.datePublishRange
                                                  .startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.filterQuery.datePublishRange
                                                  .endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.tag, function(tag) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(tag)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.socialSeries, function(
                                  socialSeries
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(socialSeries)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(socialSeries.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.socialCampaign, function(
                                  socialCampaign
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(
                                            socialCampaign
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(socialCampaign.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.department, function(
                                  department
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(department)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(department.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.filterQuery.project, function(
                                  project
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(project)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(project.title))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.filterQuery.noDepartment == "accepted"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "calendar"
                      ? _c(
                          "div",
                          { staticClass: "ml-2 calendar-type-control" },
                          [
                            _c(
                              "label",
                              { staticClass: "btn-theme date-filter-triggers" },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "deliverables",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "deliverables",
                                      value: "deliverables",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "deliverables"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Deliverables\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn-theme ml-2 date-filter-triggers"
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "tasks",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "tasks",
                                      value: "tasks",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode("tasks")
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Tasks\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn-theme ml-2 date-filter-triggers"
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "projects",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "projects",
                                      value: "projects",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "projects"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Projects\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "mediaCallPage"
                      ? _c("div", { staticClass: "new-deliverables mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "media_call",
                                    name: "Media Call"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v("\n              New Media Call "),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "socialMedia"
                      ? _c("div", { staticClass: "new-deliverables mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "social_media",
                                    name: "Social Media"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v("\n              New Social Media Post "),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkCalendarMode(["deliverables", "tasks"])
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "filter-item item__socialCampaigns mr-2",
                            staticStyle: { "max-width": "200px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "socialCampaigns-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "socialCampaignsFilter",
                                    attrs: {
                                      options: _vm.socialCampaigns,
                                      "show-labels": false,
                                      multiple: true,
                                      "open-direction": "bottom",
                                      label: "name",
                                      "track-by": "id",
                                      hideSelected: false,
                                      "hide-selected": false,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      loading: _vm.isSocialCampaignsLoading,
                                      "preserve-search": true,
                                      placeholder: "Social Campaign"
                                    },
                                    on: {
                                      "search-change":
                                        _vm.onSocialCampaignSearch
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var values = ref.values
                                            var search = ref.search
                                            var isOpen = ref.isOpen
                                            return [
                                              values.length && !isOpen
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__single"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " options selected"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      249740006
                                    ),
                                    model: {
                                      value: _vm.filterQuery.socialCampaign,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterQuery,
                                          "socialCampaign",
                                          $$v
                                        )
                                      },
                                      expression: "filterQuery.socialCampaign"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "Start typing to find social campaign."
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "No results. Please try changing the search query."
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkCalendarMode(["deliverables", "tasks"])
                      ? _c(
                          "div",
                          { staticClass: "filter-item item__socialSeries" },
                          [
                            _c(
                              "div",
                              { staticClass: "socialSeries-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "socialSeriesFilter",
                                    attrs: {
                                      options: _vm.socialSeriesPlural,
                                      "show-labels": false,
                                      multiple: true,
                                      "open-direction": "bottom",
                                      label: "name",
                                      "track-by": "id",
                                      hideSelected: false,
                                      "hide-selected": false,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      loading: _vm.isSocialSeriesLoading,
                                      "preserve-search": true,
                                      placeholder: "Social Series"
                                    },
                                    on: {
                                      "search-change": _vm.onSocialSeriesSearch
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var values = ref.values
                                            var search = ref.search
                                            var isOpen = ref.isOpen
                                            return [
                                              values.length && !isOpen
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__single"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " options selected"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      249740006
                                    ),
                                    model: {
                                      value: _vm.filterQuery.socialSeries,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterQuery,
                                          "socialSeries",
                                          $$v
                                        )
                                      },
                                      expression: "filterQuery.socialSeries"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "Start typing to find social serices."
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "No results. Please try changing the search query."
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch" &&
                    _vm.$router.currentRoute.name != "calendar"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-expand-ctrls cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "header-filter-btns expand-ctrls",
                                attrs: { variant: "theme" },
                                on: {
                                  click: function($event) {
                                    _vm.expandAll = !_vm.expandAll
                                    _vm.toggleStatusView()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.expandAll,
                                        expression: "!expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-expand fa-fw"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.expandAll,
                                        expression: "expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-compress fa-fw"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "myWeek" ||
                    _vm.$router.currentRoute.name == "dashboard"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-views-section cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.headerViewSelectModal",
                                    modifiers: { headerViewSelectModal: true }
                                  }
                                ],
                                ref: "MobileViewButton",
                                staticClass: "header-view-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "MobileViewButton"
                                }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-fw fa-eye text-primary"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                ref: "GSCreatedDate",
                                staticClass: "ml-md-2 header-filter-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "GSCreatedDate"
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs.GSCreatedDatePopover.$emit(
                                      "close"
                                    )
                                  },
                                  click: function($event) {
                                    _vm.GSCreatedDatePopover = !_vm.GSCreatedDatePopover
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Created Date\n              "
                                ),
                                _c("i", {
                                  staticClass:
                                    "far fa-calendar-check text-primary"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                ref: "GSCreatedDatePopover",
                                attrs: {
                                  show: _vm.GSCreatedDatePopover,
                                  target: "GSCreatedDate",
                                  triggers: "click blur",
                                  placement: "bottom",
                                  "custom-class":
                                    "filter_popover__gs created-date-popover"
                                },
                                on: {
                                  "update:show": function($event) {
                                    _vm.GSCreatedDatePopover = $event
                                  }
                                }
                              },
                              [
                                _c("date-range-picker", {
                                  ref: "pickerDateCreated",
                                  attrs: {
                                    opens: "inline",
                                    autoApply: true,
                                    ranges: _vm.customCreatedDateRanges
                                  },
                                  on: { update: _vm.onUpdateDateCreated },
                                  model: {
                                    value: _vm.filterQuery.dateCreatedRange,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterQuery,
                                        "dateCreatedRange",
                                        $$v
                                      )
                                    },
                                    expression: "filterQuery.dateCreatedRange"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags" ||
                      _vm.GSDataType == "contacts" ||
                      _vm.GSDataType == "coordinators")
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-md-2 toggle-dept-status cursor-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.filterQuery.status[0] == "Active"
                                      ? (_vm.filterQuery.status = ["Archived"])
                                      : (_vm.filterQuery.status = ["Active"])
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Active"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Active\n                "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-on text-primary float-right ml-2"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Archived"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Archived\n                "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-off text-primary float-right ml-2"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search sorting"
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedDesc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Decending")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedAsc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Ascending")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType == "all"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "ml-md-2 header-filter-btns dropdown-toggle",
                                attrs: {
                                  variant: "theme",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [_vm._v("Add")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _vm.userAbilities.createTag ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "tag")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Tags")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createContact ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "contact")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Contacts")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "coordinator"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add User")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createDepartment ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "department"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add Departments")]
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType != "all"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search specific-btn",
                            class: !_vm.checkPermissions ? "no-permission" : ""
                          },
                          [
                            _vm.checkPermissions
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "ml-md-2 header-filter-btns action",
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "click",
                                          _vm.GSDataType.substring(
                                            0,
                                            _vm.GSDataType.length - 1
                                          )
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Add\n              "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "capitalize"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.tabType))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _vm.checkPermissions
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme dropdown-toggle options",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Toggle Dropdown")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkPermissions
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "ml-md-2 header-filter-btns dropdown-toggle",
                                        attrs: {
                                          variant: "theme",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [_vm._v("Add")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _vm.GSDataType != "tags" &&
                                  (_vm.userAbilities.createTag ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit("click", "tag")
                                            }
                                          }
                                        },
                                        [_vm._v("Add Tags")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "contacts" &&
                                  (_vm.userAbilities.createContact ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "contact"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Contacts")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "coordinators" &&
                                  _vm.userAbilities.createUser
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "coordinator"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add User")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "departments" &&
                                  (_vm.userAbilities.createDepartment ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "department"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Departments")]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = null
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.publishStatus, function(
                      publishStatus
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge mr-2 mb-2",
                          style: {
                            cursor: "pointer",
                            color: "#fff",
                            backgroundColor: publishStatus.color
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(publishStatus)
                            }
                          }
                        },
                        [_vm._v(_vm._s(publishStatus.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "#fff" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartTagSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "usedDesc"
                                  ? "Frequency Descending"
                                  : "Frequency Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.socialNetwork, function(
                      socialNetwork
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass:
                            "badge mr-2 mb-2 bg-primary cursor-pointer",
                          staticStyle: { color: "#fff" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialNetwork)
                            }
                          }
                        },
                        [
                          _c("i", {
                            class: "fab fa-" + socialNetwork.api_type
                          }),
                          _vm._v(" " + _vm._s(socialNetwork.network_name))
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByPublishDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByPublishDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Date to Post: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.socialSeries, function(
                      socialSeries
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialSeries)
                            }
                          }
                        },
                        [_vm._v(_vm._s(socialSeries.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.socialCampaign, function(
                      socialCampaign
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialCampaign)
                            }
                          }
                        },
                        [_vm._v(_vm._s(socialCampaign.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.department, function(department) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.project, function(project) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(project)
                            }
                          }
                        },
                        [_vm._v(_vm._s(project.title))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noDepartment = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.overdue
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("overdue")
                              }
                            }
                          },
                          [_vm._v("overdue")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.today
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("today")
                              }
                            }
                          },
                          [_vm._v("today")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.thisWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("thisWeek")
                              }
                            }
                          },
                          [_vm._v("this week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.nextWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("nextWeek")
                              }
                            }
                          },
                          [_vm._v("next week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.upcoming
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("upcoming")
                              }
                            }
                          },
                          [_vm._v("upcoming")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.noDeadline
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("noDeadline")
                              }
                            }
                          },
                          [_vm._v("no deadline")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme ml-md-2 header-filter-btns dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n              Sort\n              "),
        _c("i", { staticClass: "fas fa-sort text-primary float-right" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }